import { Flex, Spinner, Text } from '@chakra-ui/react';
const Loader = (): JSX.Element => {
    return (
        <Flex direction={'column'} align={'center'} justify={'center'} height={'100vh'} gap={3}>
            <Spinner size={'lg'} />
            <Text color={'secondary.solid'} mt={1}>
                Trwa ładowanie...
            </Text>
        </Flex>
    );
};

export { Loader };
